@use "../../../globals/settings";
@use "../../../globals/bcp-2022/objects/forms/text-field";
@use "../../../globals/bcp";

$self: ".a-text-field";

:host {
  // ------------------- FIX CUSTOM TAGS ------------------------------------------------------------------------------
  display: block;
}

// ------------------- NORMALIZE & RESET ----------------------------------------------------------------------------
@include text-field.reset-type-number;

@include text-field.remove-ms-btns;

@include text-field.reset-type-search;

// ------------------- BCP ------------------------------------------------------------------------------------------
.a-text-field {
  @include text-field.text-field-wrapper;

  &__label {
    @include text-field.text-field-label;
  }

  input,
  &__input {
    @include text-field.text-field-input;

    &::placeholder {
      @include text-field.text-field-placeholder;
    }

    &:disabled {
      @include text-field.text-field-disabled;
    }
  }

  // floating label styles
  &--floating-label {
    #{$self}__label {
      @include text-field.floating-label__label;
    }

    #{$self}__input {
      @include text-field.floating-label__input;
    }

    &#{$self}--disabled {
      #{$self}__label {
        color: text-field.$input-disabled-color;
      }
    }
  }
}

.acc-hide {
  @include bcp.acc-hide;
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
